import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";

const examples = [
  {
    label: "Przykład 1. Skracanie wspólnego czynnika",
    summary: "Skracamy czynniki, a nie składniki sumy",
    content: (
      <>
        <BlockMath math="\frac{(x-3)(x+2)}{x-3}=x+2,\qquad x\neq3" />
        <p>
          Nawias <InlineMath math="x-3" /> jest wspólnym czynnikiem licznika
          i mianownika. Warunek <InlineMath math="x\neq3" /> pozostaje także
          po skróceniu.
        </p>
      </>
    ),
  },
  {
    label: "Przykład 2. Rozkład licznika",
    summary: "Różnica kwadratów pozwala skrócić ułamek",
    content: (
      <>
        <BlockMath math="\frac{x^2-16}{x-4}=\frac{(x-4)(x+4)}{x-4}=x+4,\qquad x\neq4" />
        <p>
          Przed skracaniem rozkładamy wielomian na czynniki, korzystając ze
          wzoru <InlineMath math="a^2-b^2=(a-b)(a+b)" />.
        </p>
      </>
    ),
  },
  {
    label: "Przykład 3. Ułamek równy zero",
    summary: "Do zera przyrównujemy licznik",
    content: (
      <>
        <BlockMath math="\frac{2x-6}{x+1}=0,\qquad x\neq-1" />
        <BlockMath math="2x-6=0\quad\Rightarrow\quad x=3" />
        <p>
          Ułamek jest równy zero wtedy, gdy jego licznik jest równy zero,
          a mianownik jest różny od zera.
        </p>
      </>
    ),
  },
  {
    label: "Przykład 4. Ułamek równy liczbie",
    summary: "Mnożymy obie strony przez mianownik",
    content: (
      <>
        <BlockMath math="\frac{3x-2}{x+2}=2,\qquad x\neq-2" />
        <BlockMath math="3x-2=2(x+2)\quad\Rightarrow\quad x=6" />
      </>
    ),
  },
  {
    label: "Przykład 5. Dwie frakcje",
    summary: "Po mnożeniu na krzyż może powstać równanie kwadratowe",
    content: (
      <>
        <BlockMath math="\frac{x+1}{x-1}=\frac{2x}{x+2},\qquad x\neq1,\;-2" />
        <BlockMath math="(x+1)(x+2)=2x(x-1)" />
        <BlockMath math="x^2+3x+2=2x^2-2x\quad\Rightarrow\quad x^2-5x-2=0" />
        <p>
          Dalej rozwiązujemy zwykłe równanie kwadratowe, a na końcu odrzucamy
          ewentualne wyniki niedozwolone przez mianowniki.
        </p>
      </>
    ),
  },
];

export default function RationalExpressionsEquationsPreparationTheory() {
  return (
    <TheoryExamplesRunner
      title="Wyrażenia i równania wymierne"
      intro={(
        <>
          <p>
            <strong>Wyrażenie wymierne</strong> ma postać ilorazu wielomianów:
          </p>
          <BlockMath math="\frac{P(x)}{Q(x)},\qquad Q(x)\neq0" />
          <p>
            Najpierw zapisujemy krótki warunek wynikający z mianownika. Potem
            rozkładamy licznik i mianownik na czynniki i skracamy wyłącznie
            wspólne <strong>czynniki</strong> — nie pojedyncze składniki sumy.
          </p>
          <p>
            W równaniu wymiernym usuwamy mianowniki, rozwiązujemy otrzymane
            równanie liniowe albo kwadratowe i sprawdzamy, czy wynik nie zeruje
            któregoś z mianowników. Nawet gdy polecenie maturalne nie wymaga
            osobnego zapisu dziedziny, ten warunek nadal trzeba uwzględnić.
          </p>
        </>
      )}
      examples={examples}
    />
  );
}
